<div class="details-wrapper" xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html"
     xmlns="http://www.w3.org/1999/html" xmlns="http://www.w3.org/1999/html">
    <div class="details-container">
        @if (pureOriginalService.imageIsLoading()) {
            <app-pure-original-info-skeleton></app-pure-original-info-skeleton>
        }
        @if (!pureOriginalService.imageIsLoading()) {
            <form class="vehicle-info-container">
                @if (pureOriginalDetailObject()) {
                    <ng-container>
                        <div class="title-image-wrapper">
                            <div class="header-info-container">
                                <div class="title">
                                    <span class="content-item-text">
                                        {{ pureOriginalDetailObject()["vehicleProducer"] }}
                                        {{ pureOriginalDetailObject()["vehicleSeries"] | shorten: 17 }}
                                        {{ pureOriginalDetailObject()["vehicleModelYear"] }}
                                    </span>
                                </div>
                            </div>
                            <div class="vehicle-info-card">
                                <img [src]="carImageService.image" alt=""
                                     [ngClass]="!carImageService.image ? 'startLoad' : ''">
                            </div>
                        </div>

                        <div class="cta-stack">
                            <button class="primary-gradient-btn"
                                    type="button"
                                    (click)="downloadBaseFile()"
                                    [disabled]="isDownloadInProgress(pureOriginalId())">
                                <span>Download</span>
                                <i class="bi bi-arrow-down-short"></i>
                            </button>

                            <button class="secondary-outline-btn"
                                    type="button"
                                    (click)="restartProcess()">
                                Reprocess Pure Original
                            </button>
                        </div>

                        <div class="actions-block">
                            <div class="actions-row">
                                <button class="secondary-gradient-btn"
                                        type="button"
                                        (click)="uploadIniAction()"
                                        [disabled]="buttonIsDisabled()"
                                        [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''">
                                    Upload INI
                                    <i class="bi bi-arrow-up-short"></i>
                                </button>

                                <button class="secondary-gradient-btn"
                                        type="button"
                                        (click)="addTuning()"
                                        [disabled]="buttonIsDisabled()"
                                        [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''">
                                    Add Tuning
                                    <i class="bi bi-plus-lg"></i>
                                </button>
                            </div>

                            <button class="primary-gradient-btn"
                                    type="button"
                                    (click)="downloadPartialTuningsAction()"
                                    [disabled]="isDownloadInProgress(pureOriginalId()) || buttonIsDisabled()"
                                    [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''">
                                <span>Download Partial Tunings</span>
                                <i class="bi bi-arrow-down-short"></i>
                            </button>

                            <div class="footer-row">
                                <button class="text-icon-btn"
                                        type="button"
                                        (click)="editTuning()"
                                        [disabled]="buttonIsDisabled()"
                                        [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''">
                                    <i class="bi bi-pencil"></i>
                                    <span>Edit</span>
                                </button>

                                @if (isSuperAdmin()) {
                                    <button class="text-icon-btn"
                                            type="button"
                                            #historyTooltip="matTooltip"
                                            (click)="openHistoryModal(pureOriginalId())"
                                            [matTooltip]="tooltipMessage()"
                                            matTooltipPosition="above">
                                        <i class="bi bi-clock-history"></i>
                                        <span>History</span>
                                    </button>
                                }

                                <button class="text-icon-btn danger"
                                        type="button"
                                        (click)="deleteAction()"
                                        [disabled]="buttonIsDisabled()"
                                        [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''">
                                    <i class="bi bi-trash"></i>
                                    <span>Delete</span>
                                </button>
                            </div>

                            <input id="fileInput"
                                   class="file-upload-input"
                                   type="file"
                                   style="display: none;"
                                   [disabled]="buttonIsDisabled()"
                                   (change)="uploadIni($event)"/>
                        </div>

                        <form [formGroup]="pureOriginalDetailsFormGroup" (keydown.enter)="submitForm()"
                              (keydown.escape)="cancelForm()">
                            <div class="column-wrapper">
                                <div class="info-card-details base-details" [class.expanded]="showMore">
                                    <div class="info-column">
                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">New WinOls Name</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()['winOlsDbName'] || ''| shorten: 30 }}</span></span>
                                        <span class="matching-detail-item">
                                        <span class="matching-item-name">Ecu Producer</span>
                                            @if (!editFlags.ecuProducer) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuProducer', $event)">{{ pureOriginalDetailsFormGroup.get('ecuProducer').value ? pureOriginalDetailObject()["ecuProducer"] : '' }}
                                        </span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuProducer"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                       </span>
                                        <span class="matching-detail-item">
                                        <span class="matching-item-name">Ecu Build</span>
                                            @if (!editFlags.ecuBuild) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuBuild', $event)">{{ pureOriginalDetailsFormGroup.get('ecuBuild').value ? pureOriginalDetailObject()["ecuBuild"] : '' }}
                                           </span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuBuild"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                     </span>
                                        <span class="matching-detail-item">
                                       <span class="matching-item-name">Ecu Software Version</span>
                                            @if (!editFlags.ecuSoftwareVersion) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuSoftwareVersion', $event)">{{ pureOriginalDetailsFormGroup.get('ecuSoftwareVersion').value ? pureOriginalDetailObject()['ecuSoftwareVersion'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuSoftwareVersion"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                          </span>

                                        <span class="matching-detail-item">
                                       <span class="matching-item-name">Ecu Software Version Version</span>
                                            @if (!editFlags.ecuSoftwareVersionVersion) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuSoftwareVersionVersion', $event)">{{ pureOriginalDetailsFormGroup.get('ecuSoftwareVersionVersion').value ? pureOriginalDetailObject()['ecuSoftwareVersionVersion'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuSoftwareVersionVersion"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                   </span>


                                        <span class="matching-detail-item">
                                             <span class="matching-item-name">Ecu Prod Nr</span>
                                            @if (!editFlags.ecuProdNr) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuProdNr', $event)">{{ pureOriginalDetailsFormGroup.get('ecuProdNr').value ? pureOriginalDetailObject()['ecuProdNr'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuProdNr"
                                                       (click)="stopPropagation($event)"
                                                />
                                            }
                                        </span>

                                    </div>
                                    <div class="info-column">
                                        <span class="matching-detail-item">
                                      <span class="matching-item-name">Reading Hardware</span>
                                            @if (!editFlags.readingHardware) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('readingHardware', $event)">{{ pureOriginalDetailsFormGroup.get('readingHardware').value ? pureOriginalDetailObject()['readingHardware'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="readingHardware"
                                                       (click)="stopPropagation($event)"
                                                />
                                            }
                                       </span>

                                        <span class="matching-detail-item">
                                       <span class="matching-item-name">Vehicle Producer</span>
                                            @if (!editFlags.vehicleProducer) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleProducer', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleProducer').value ? pureOriginalDetailObject()['vehicleProducer'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleProducer"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                   </span>

                                        <span class="matching-detail-item">
                                  <span class="matching-item-name">Vehicle Series</span>
                                            @if (!editFlags.vehicleSeries) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleSeries', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleSeries').value ? pureOriginalDetailObject()['vehicleSeries'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleSeries"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                   </span>

                                        <span class="matching-detail-item">
                                  <span class="matching-item-name">Vehicle Model</span>
                                            @if (!editFlags.vehicleModel) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleModel', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleModel').value ? pureOriginalDetailObject()['vehicleModel'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleModel"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                    </span>
                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Engine Name</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()["engineName"] || '-' }}</span></span>

                                        <span class="matching-detail-item">
                                      <span class="matching-item-name">Ecu StgNr</span>
                                            @if (!editFlags.ecuStgNr) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuStgNr', $event)">{{ pureOriginalDetailsFormGroup.get('ecuStgNr').value ? pureOriginalDetailObject()['ecuStgNr'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuStgNr"
                                                       (click)="stopPropagation($event)"
                                                />
                                            }
                                      </span>

                                    </div>

                                    <div class="more-details-wrapper" @expandCollapse *ngIf="showMore">
                                        <div class="more-details-columns">
                                            <div class="info-column">

                                        <span class="matching-detail-item"><span
                                                     class="matching-item-name">WinOLS</span><span
                                                     class="matching-item-text">{{ pureOriginalDetailObject()['winOlsReference'] || '' | shorten: 25 }}</span></span>

                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Tunings</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()['numberOfOptions'] || '' }}</span></span>

                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Client Counter</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()["clientImportCounter"] || '' }}</span></span>
                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Master Counter</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()["masterUploadCounter"] || '' }}</span></span>

                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Date Exported</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()['dateExported'] || ''| shorten: 30 }}</span></span>

                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Date Uploaded</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()["dateUploaded"] || '' | shorten: 20 }}</span></span>
                                        <span class="matching-detail-item"><span
                                                class="matching-item-name">Date Updated</span><span
                                                class="matching-item-text">{{ pureOriginalDetailObject()["dateUpdated"] || '' | shorten: 20 }}</span></span>
                                        <span class="matching-detail-item">
                                        <span class="matching-item-name">Type</span>
                                            @if (!editFlags.engineType) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('engineType', $event)">{{ pureOriginalDetailsFormGroup.get('engineType').value ? pureOriginalDetailObject().engineType : "" }}
                                        </span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="engineType"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                        </span>

                                        <span class="matching-detail-item">
                                        <span class="matching-item-name">Transmission</span>
                                            @if (!editFlags.engineTransmission) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('engineTransmission', $event)">{{ pureOriginalDetailsFormGroup.get("engineTransmission").value ? pureOriginalDetailObject()["engineTransmission"] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="engineTransmission"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                        </span>
                                        <span class="matching-detail-item">
                                        <span class="matching-item-name">Engine Producer</span>
                                            @if (!editFlags.engineProducer) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('engineProducer', $event)">{{ pureOriginalDetailsFormGroup.get('engineProducer').value ? pureOriginalDetailObject()['engineProducer'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="engineProducer"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                        </span>

                                        <span class="matching-detail-item">
                                            <span class="matching-item-name">Displacement</span>
                                            @if (!editFlags.engineDisplacement) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('engineDisplacement', $event)">{{ pureOriginalDetailsFormGroup.get('engineDisplacement').value ? pureOriginalDetailObject()["engineDisplacement"] : '' }}
                                             </span>
                                            } @else {
                                                <input type="text" class="matching-item-text new-text"
                                                       formControlName="engineDisplacement"
                                                       (click)="stopPropagation($event)"/>
                                                @if (isInputChanged()) {
                                                    <span *ngIf="pureOriginalDetailsFormGroup.get('engineDisplacement').hasError('pattern')"
                                                          class="error-tooltip">Only accepts formats like this -> 100.0 or 100</span>
                                                }
                                            }
                                            </span>


                                    </div>

                                    <div class="info-column">
                                        <span class="matching-detail-item">
                                             <span class="matching-item-name">Vehicle Build</span>
                                            @if (!editFlags.vehicleBuild) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleBuild', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleBuild').value ? pureOriginalDetailObject()['vehicleBuild'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleBuild"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                         </span>
                                        <span class="matching-detail-item">
                                       <span class="matching-item-name">Vehicle Type</span>
                                            @if (!editFlags.vehicleType) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleType', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleType').value ? pureOriginalDetailObject()['vehicleType'] : '' }}</span>

                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleType"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                     </span>
                                        <span class="matching-detail-item">
                                     <span class="matching-item-name">Vehicle Model Year</span>
                                            @if (!editFlags.vehicleModelYear) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleModelYear', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleModelYear').value ? pureOriginalDetailObject()['vehicleModelYear'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleModelYear"
                                                       (click)="stopPropagation($event)"/>
                                            }
                                      </span>
                                        <span class="matching-detail-item">
                                      <span class="matching-item-name">Vehicle Characteristic</span>
                                            @if (!editFlags.vehicleCharacteristic) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('vehicleCharacteristic', $event)">{{ pureOriginalDetailsFormGroup.get('vehicleCharacteristic').value ? pureOriginalDetailObject()['vehicleCharacteristic'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="vehicleCharacteristic"
                                                       (click)="stopPropagation($event)"
                                                />
                                            }
                                        </span>
                                        <span class="matching-detail-item">
                                      <span class="matching-item-name">Ecu Use</span>
                                            @if (!editFlags.ecuUse) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('ecuUse', $event)">{{ pureOriginalDetailsFormGroup.get('ecuUse').value ? pureOriginalDetailObject()['ecuUse'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="ecuUse"
                                                       (click)="stopPropagation($event)"
                                                />
                                            }
                                         </span>

                                        <span class="matching-detail-item">
                                     <span class="matching-item-name">Hp</span>
                                            @if (!editFlags.outputPs) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('outputPs', $event)">{{ pureOriginalDetailsFormGroup.get('outputPs').value ? pureOriginalDetailObject()['outputPs'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="outputPs"

                                                       (click)="stopPropagation($event)"/>
                                                @if (isInputChanged()) {
                                                    <span *ngIf="pureOriginalDetailsFormGroup.get('outputPs').hasError('pattern')"
                                                          class="error-tooltip">Only accepts formats like this -> 100.0 or 100</span>
                                                }
                                            }
                                   </span>

                                        <span class="matching-detail-item">
                                    <span class="matching-item-name">Kw</span>
                                            @if (!editFlags.outputKw) {
                                                <span class="matching-item-text cursor"
                                                      [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                      (click)="toggleEdit('outputKw', $event)">{{ pureOriginalDetailsFormGroup.get('outputKw').value ? pureOriginalDetailObject()['outputKw'] : '' }}</span>
                                            } @else {
                                                <input type="text" class="matching-item-text"
                                                       formControlName="outputKw"
                                                       (click)="stopPropagation($event)"/>
                                                @if (isInputChanged()) {
                                                    <span *ngIf="pureOriginalDetailsFormGroup.get('outputKw').hasError('pattern')"
                                                          class="error-tooltip">Only accepts formats like this -> 100.0 or 100</span>
                                                }
                                            }
                                  </span>
                                        <span class="matching-detail-item">
                                       <span class="matching-item-name">Nm</span>
                                            @if (!editFlags.engineMaxTorque) {
                                                <span
                                                        class="matching-item-text cursor"
                                                        [matTooltip]="buttonIsDisabled() ? 'Please claim the file' : ''"
                                                        (click)="toggleEdit('engineMaxTorque', $event)">{{ pureOriginalDetailsFormGroup.get('engineMaxTorque').value ? pureOriginalDetailObject()['engineMaxTorque'] : '' }}</span>
                                            } @else {

                                                <input type="text" class="matching-item-text"
                                                       formControlName="engineMaxTorque"
                                                       (click)="stopPropagation($event)"/>
                                                @if (isInputChanged()) {
                                                    <span *ngIf="pureOriginalDetailsFormGroup.get('engineMaxTorque').hasError('pattern')"
                                                          class="error-tooltip">Only accepts formats like this -> 100.0 or 100 </span>
                                                }
                                            }
                                 </span>


                                    </div>
                                </div>
                            </div>

                            <div class="details-toggle-row">
                                <button type="button"
                                        class="details-toggle-btn"
                                        (click)="toggleShowMore()"
                                        [attr.aria-expanded]="showMore">
                                    <i class="bi"
                                       [class.bi-chevron-down]="!showMore"
                                       [class.bi-chevron-up]="showMore"></i>
                                </button>
                            </div>

                            </div>
                            </div>

                            @if (isVisibleButton()) {
                                <div class="save-button">
                                    <button type="button" class="add-tuning-button"
                                            (click)="submitForm()" [disabled]="!pureOriginalDetailsFormGroup.valid">Save
                                    </button>
                                    <button type="button" class="add-tuning-button"
                                            (click)="cancelForm()">Cancel
                                    </button>
                                </div>
                            }
                        </form>
                    </ng-container>
                }
            </form>
        }
    </div>
</div>
